import { createAsyncThunk } from "@reduxjs/toolkit";
// import { baseUrl } from "../../boot/index";
import { baseUrl } from "../../boot";
import axios from "axios";

// get  Timesheet 
export const getRoles = createAsyncThunk("get-role-list", async (data) => {
    const token = localStorage.getItem("authToken")
    try {
        const response = await axios.post(`${baseUrl}cleaningappfunctions/user/app/v1/get-role-list`, data, { 
            headers: {
                "auth-token": token,
            }
        },);
        return response;
    } catch (error) {
        console.error('Error fetching timesheet - ', error);
        throw error;
    }
})



